import toArray from '../../../frontend/scripts/utils/to-array';

export default () => {
  const audioPlayerContainers = toArray(
    document.querySelectorAll('.js-audio-player')
  );

  if (!audioPlayerContainers) {
    return;
  }

  audioPlayerContainers.forEach(audioPlayerContainer => {
    const scheduleId = audioPlayerContainer.dataset.scheduleId;
    const expandState = audioPlayerContainer.dataset.expandState;

    const parentElement = audioPlayerContainer.parentElement;

    const playerContainerId = audioPlayerContainer.dataset.playerContainer;
    const playerElementId = audioPlayerContainer.dataset.playerElement;
    const playerId = audioPlayerContainer.dataset.playerId;
    const accountId = audioPlayerContainer.dataset.accountId;
    const audioId = audioPlayerContainer.dataset.audioId;
    const adserverUrl = audioPlayerContainer.dataset.adserverUrl;
    const spacerId = audioPlayerContainer.dataset.spacerId;

    const logo = audioPlayerContainer.dataset.logo;
    const backgroundOne = audioPlayerContainer.dataset.backgroundOne;
    const backgroundTwo = audioPlayerContainer.dataset.backgroundTwo;
    const backgroundSplit = audioPlayerContainer.dataset.backgroundSplit;
    const iheartUrl = audioPlayerContainer.dataset.iheartUrl;

    import('./AudioPlayer' /* webpackChunkName: "audioplayer" */).then(
      ({ initializeAudioPlayer }) => {
        initializeAudioPlayer(audioPlayerContainer, {
          scheduleId,
          parentElement,
          expandState,
          playerContainerId,
          playerElementId,
          playerId,
          accountId,
          audioId,
          adserverUrl,
          spacerId,
          logo,
          backgroundOne,
          backgroundTwo,
          backgroundSplit,
          iheartUrl,
        });
      }
    );
  });
};
